import CommonDetailsDialog from "@/components/common/details/DetailsDialog"
import { Badge } from "@/components/ui/badge"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { sheet } from "@/interface/dataInterface"
import { PartnerData } from "@/interface/entityInterface"
import { Phone, Percent, Mail, Calendar } from "lucide-react"
import { FC } from "react"

interface PartnersDetailsDialog extends sheet {
    partner: PartnerData | null
}

const PartnersDetails: FC<PartnersDetailsDialog> = ({open, setOpen, partner}) => {
    if (!partner) return null;

    return (
        <CommonDetailsDialog open={open} setOpen={setOpen} title="">
            <div className="grid gap-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Partner Information</CardTitle>
            </CardHeader>
            <CardContent className="grid gap-3">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-muted-foreground" />
                <span>{partner.phone}</span>
              </div>
              <div className="flex items-center gap-2">
                <Percent className="h-4 w-4 text-muted-foreground" />
                <span>{partner.percentage_commission}% Commission</span>
              </div>
              <div className="flex items-center gap-2">
                <Badge variant={partner.is_active ? 'default' : 'secondary'}>
                  {partner.is_active ? 'Active' : 'Inactive'}
                </Badge>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-lg">User Details</CardTitle>
            </CardHeader>
            <CardContent className="grid gap-3">
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-muted-foreground" />
                <span>{partner.user.email}</span>
              </div>
              <div className="flex items-center gap-2">
                <Badge variant="outline">{partner.user.user_role}</Badge>
              </div>
              <div className="flex items-center gap-2">
                <Badge variant={partner.user.active ? 'default' : 'destructive'}>
                  {partner.user.active ? 'Active' : 'Inactive'}
                </Badge>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Timestamps</CardTitle>
            </CardHeader>
            <CardContent className="grid gap-3">
              <div className="flex items-center gap-2">
                <Calendar className="h-4 w-4 text-muted-foreground" />
                <span>Created: {new Date(partner.createdAt).toLocaleDateString()}</span>
              </div>
              <div className="flex items-center gap-2">
                <Calendar className="h-4 w-4 text-muted-foreground" />
                <span>Updated: {new Date(partner.updatedAt).toLocaleDateString()}</span>
              </div>
            </CardContent>
          </Card>
        </div>
        </CommonDetailsDialog>
    )
}

export default PartnersDetails